/* eslint-disable prettier/prettier */

import { useState, useEffect, useCallback } from 'react';

import {
	programOverviewService,
	ProgramOverviewRow,
	ProgramOverviewFilters,
} from '../services/programOverview.service';

export const useProgramsOverview = (
	initialFilters?: ProgramOverviewFilters
) => {
	const [programs, setPrograms] = useState<ProgramOverviewRow[]>([]);

	const [total, setTotal] = useState<number>(0);

	const [page, setPage] = useState<number>(initialFilters?.page || 1);

	const [limit, setLimit] = useState<number>(initialFilters?.limit || 10);

	const [loading, setLoading] = useState<boolean>(false);

	const [error, setError] = useState<string | null>(null);

	const [filters, setFilters] = useState<ProgramOverviewFilters>(
		initialFilters || {}
	);

	const fetchProgramsOverview = useCallback(
		async (overrideFilters?: ProgramOverviewFilters) => {
			try {
				setLoading(true);
				setError(null);

				const finalFilters = {
					...filters,
					...overrideFilters,
				};

				const response =
					await programOverviewService.getProgramsOverview(
						finalFilters
					);

				setPrograms(response.programs || []);

				setTotal(response.total || 0);

				setPage(response.page || 1);

				setLimit(response.limit || 10);

				return response;
			} catch (err: any) {
				const message =
					err?.message || 'Failed to fetch programs overview';

				setError(message);

				throw err;
			} finally {
				setLoading(false);
			}
		},
		[filters]
	);

	useEffect(() => {
		fetchProgramsOverview();
	}, [fetchProgramsOverview]);

	const updateFilters = (newFilters: ProgramOverviewFilters) => {
		setFilters(prev => ({
			...prev,
			...newFilters,
		}));
	};

	const refresh = async () => {
		await fetchProgramsOverview();
	};

	return {
		programs,
		total,
		page,
		limit,
		loading,
		error,

		filters,
		setFilters: updateFilters,

		fetchProgramsOverview,
		refresh,
	};
};
